export function getBaseStyle(isMobile: boolean) {
  return { cursor: 'pointer', height: isMobile ? '72px' : '220px' };
}
